export default __webpack_public_path__ + "static/media/icons8-twitter.0521e950.svg";